import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { COMMENTS } from '@/store/entities/schema_types';
import { contactRequestCommentsClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(COMMENTS),
  actions: {
    ...resourceActions,
    async load(ctx, { id, query = {} }) {
      try {
        const response = await client.list(id, query);

        const { data, meta } = response;

        const commentIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: COMMENTS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: id,
          ids: commentIds,
        });

        return Promise.resolve({ commentIds, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async store(ctx, { id, formData }) {
      try {
        const response = await client.store(id, mapKeysToSnakeCase(formData));

        const commentId = await ctx.dispatch(
          'entities/persistEntities',
          { type: COMMENTS, data: response.data },
          { root: true }
        );

        ctx.commit({
          type: 'addIdToParent',
          parentId: id,
          id: commentId,
        });

        return Promise.resolve(commentId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
